import _extends from "@babel/runtime/helpers/extends";
import { Spin, Form, Button, Input, Select, App } from "antd";
import { observer } from "mobx-react";
import { useMemo } from "react";
import { useState, useCallback, useEffect } from "react";
import { IMPREZA_BUTTON_PROPS, __ } from "../../../../utils";
import { RealCommerceError } from "../../../../exceptions";
import { useRealCommerceErrorHandling } from "../../../../hooks";
import { EProductPlanPaymentInterval } from "@devowl-wp/api-real-commerce";
import { useStores } from "../../../../store";
import { AccountAffiliateCouponsTable } from ".";
const AccountAffiliateCouponsFormLayout = {
  labelCol: {
    span: 6
  },
  wrapperCol: {
    span: 16
  }
};
const AccountAffiliateCouponsForm = observer(() => {
  const {
    message
  } = App.useApp();
  const [busy, setBusy] = useState(false);
  const initialValues = {
    code: "",
    products: []
  };
  const [form] = Form.useForm();
  const handleRealCommerceError = useRealCommerceErrorHandling();
  const {
    accountStore
  } = useStores();
  const {
    session: {
      affiliate
    },
    busyAffiliateProducts,
    affiliateProducts
  } = accountStore;
  useEffect(() => {
    accountStore.fetchAffiliateProducts();
  }, []);
  const onFinish = useCallback(async _ref => {
    let {
      code,
      products
    } = _ref;
    setBusy(true);
    try {
      await affiliate.createCoupon({
        code,
        products: products.map(id => ({
          id
        }))
      });
      message.success(__("Successfully created coupon. Go, and share it!"));
      form.resetFields();
    } catch (e) {
      if (e instanceof RealCommerceError) {
        handleRealCommerceError(e);
      }
    } finally {
      setBusy(false);
    }
  }, [affiliate]);
  const productGroups = useMemo(() => {
    const result = {};
    for (const product of affiliateProducts) {
      const {
        defaultPaymentInterval
      } = product;
      const defaultPaymentIntervalText = defaultPaymentInterval === EProductPlanPaymentInterval.OneTime ? __("One-time payment products") : __("Subscriptions");
      result[defaultPaymentIntervalText] = result[defaultPaymentIntervalText] || [];
      result[defaultPaymentIntervalText].push(product);
    }
    return result;
  }, [affiliateProducts]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "real-commerce-affiliate-coupon-form"
  }, /*#__PURE__*/React.createElement(Spin, {
    spinning: busy
  }, /*#__PURE__*/React.createElement("p", null, __("You can create exclusive branded coupons for our products. With them, your customers, readers and viewers can not only save money, but when using the coupon you will get a commission.")), /*#__PURE__*/React.createElement("p", null, __("For subscription product you can create coupons for %d%% discount in the first year. For one-time payment products you can create coupons for %d%% discount.", 20, 10)), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Form, _extends({
    form: form,
    onFinish: onFinish,
    initialValues: initialValues,
    colon: false,
    labelWrap: true
  }, AccountAffiliateCouponsFormLayout), /*#__PURE__*/React.createElement(Form.Item, {
    label: __("Products"),
    extra: __("Each coupon can be valid for one or multiple subscriptions or one-time payment products."),
    required: true,
    name: "products",
    rules: [{
      required: true,
      message: __("Please choose at least one product!")
    }, {
      validator: async (rule, value) => {
        const uniqueSelectedIntervals = value.map(id => affiliateProducts.filter(_ref2 => {
          let {
            id: i
          } = _ref2;
          return i === id;
        })[0].defaultPaymentInterval).filter((v, i, a) => a.indexOf(v) === i);
        if (uniqueSelectedIntervals.length > 1) {
          throw __("A coupon can be created for either subscription or one-time payments, but not for both billing types at the same time.");
        }
      }
    }]
  }, /*#__PURE__*/React.createElement(Select, {
    mode: "multiple",
    loading: busyAffiliateProducts,
    showSearch: true,
    optionFilterProp: "children"
  }, Object.keys(productGroups).map(interval => /*#__PURE__*/React.createElement(Select.OptGroup, {
    label: interval,
    key: interval
  }, productGroups[interval].map(_ref3 => {
    let {
      id,
      name
    } = _ref3;
    return /*#__PURE__*/React.createElement(Select.Option, {
      key: id,
      value: id
    }, name);
  }))))), /*#__PURE__*/React.createElement(Form.Item, {
    label: __("Coupon code"),
    extra: __('Coupons can only contain of capital letters, hyphens and dots and must not be suggestive as if it were a special sale (for example, "BLACKFRIDAY" as a code is forbidden and will be deleted by us without notice).'),
    required: true,
    name: "code",
    rules: [{
      required: true,
      message: __("Please enter a coupon code!")
    }]
  }, /*#__PURE__*/React.createElement(Input, {
    style: {
      textTransform: "uppercase"
    }
  })), /*#__PURE__*/React.createElement(Form.Item, {
    wrapperCol: {
      offset: AccountAffiliateCouponsFormLayout.labelCol.span
    }
  }, /*#__PURE__*/React.createElement(Button, _extends({
    type: "primary",
    size: "large",
    htmlType: "submit"
  }, IMPREZA_BUTTON_PROPS), __("Create coupon")))))), /*#__PURE__*/React.createElement(AccountAffiliateCouponsTable, null));
});
export { AccountAffiliateCouponsForm, AccountAffiliateCouponsFormLayout };